// extracted by mini-css-extract-plugin
export var actionButton = "_kb-t";
export var buttonContainer = "_kb-0";
export var buttonContainer2 = "_kb-1";
export var buttonSection = "_kb-2";
export var details = "_kb-3";
export var dropdownItem = "_kb-5";
export var dropdownItemsContainer = "_kb-4";
export var fileInput = "_kb-r";
export var headerButton = "_kb-6";
export var icon = "_kb-7";
export var input = "_kb-8";
export var macroListItem = "_kb-9";
export var mainContent = "_kb-a";
export var microText = "_kb-b";
export var modal = "_kb-w";
export var optionsButton = "_kb-c";
export var paperclip = "_kb-s";
export var pillContent = "_kb-d";
export var preview = "_kb-e";
export var preview2 = "_kb-f";
export var quillEditor = "_kb-q";
export var selectedMacro = "_kb-g";
export var sidebar = "_kb-h";
export var sidebarHeader = "_kb-j";
export var sidebarList = "_kb-i";
export var sidebarListItem = "_kb-k";
export var sidebarSearch = "_kb-l";
export var snoozeDurationWrapper = "_kb-v";
export var statusPillContainer = "_kb-m";
export var tagsContainer = "_kb-n";
export var unselectedMacro = "_kb-o";
export var variable = "_kb-u";
export var wrapper = "_kb-p";